import { logAPI } from "../andyliticsApi";
import { select, call } from "redux-saga/effects";
import * as tools from "../../helpers/Tools";

//const hpServicesUrl = typeof window !== 'undefined' ? window.serverData.data.hpServicesUrl : ''; // window is undefined during pre-render

//tells api where to go
export var SsoTargets = {
    alere: "Alere",
    vitals: "Vitals",
    navitus: "Navitus",
    bSwift: "BSwift",
    telemedicine: "Telemedicine",
    lifeBalance: "LifeBalance",
    optumRX: "OptumRX",
    invoicePayments: "InvoicePayments",
    naturallySlim: "NaturallySlim",
    optumWellness: "OptumWellness",
    mdLive: "MDLive",
    thrive: "Thrive",
    boa: "BOA",
    webMD: "WebMD"
}

//role required for authorized sso
export var PortalRoles = {
    optumRXSsoUsers: "OptumRxSsoUsers",
    alereSsoUsers: "AlereSsoUsers",
    bSwiftSsoUsers: "BSwiftSsoUsers",
    vitalsSsoUsers: "VitalsSsoUsers",
    navitusSsoUsers: "NavitusSsoUsers",
    telemedicineSsoUsers: "TelemedicineSsoUsers",
    lifeBalanceSsoUsers: "LifeBalanceSsoUsers",
    invoicePaymentSsoUsers: "InvoicePaymentSsoUsers",
    naturallySlimSsoUsers: "NaturallySlimSsoUsers",
    webMDSsoUsers: "WebMDSsoUsers"
}

//target to role mapping
var targetToRequiredRole = {};
targetToRequiredRole[SsoTargets.alere] = PortalRoles.alereSsoUsers;
targetToRequiredRole[SsoTargets.vitals] = PortalRoles.vitalsSsoUsers;
targetToRequiredRole[SsoTargets.navitus] = PortalRoles.navitusSsoUsers;
targetToRequiredRole[SsoTargets.bSwift] = PortalRoles.bSwiftSsoUsers;
targetToRequiredRole[SsoTargets.telemedicine] = PortalRoles.telemedicineSsoUsers;
targetToRequiredRole[SsoTargets.lifeBalance] = PortalRoles.lifeBalanceSsoUsers;
targetToRequiredRole[SsoTargets.optumRX] = PortalRoles.optumRXSsoUsers;
targetToRequiredRole[SsoTargets.invoicePayments] = PortalRoles.invoicePaymentSsoUsers;
targetToRequiredRole[SsoTargets.naturallySlim] = PortalRoles.naturallySlimSsoUsers;
targetToRequiredRole[SsoTargets.webMD] = PortalRoles.webMDSsoUsers;

export function* getUrl(ssoTarget) {
    const domainData = yield select((state) => state.domain);
    const sessionData = yield select((state) => state.session);
    var identity = sessionData.healthPlanUserProfile;

    var requiredRole = targetToRequiredRole[ssoTarget];
    if (!requiredRole) {
        console.log('sso fail - no target/role found');
        return "";
    }

    const ssoUrl = encodeURI(tools.buildUrl(tools.hpAPIBaseURL(), '/SsoResponse/'));
    //if in required role, build url
    return identity.roles.includes(requiredRole) ? `${ssoUrl}` : "";
}

export function* startSso(ssoTarget, isAmysis, contractNo) {
    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const sessionData = yield select((state) => state.session);

    let ssoWindow = window.open("", "_blank");
    ssoWindow.document.write('you will be redirected shortly...' + '<br>');
    let url = "";
    if (isAmysis) {
        url = encodeURI(tools.buildUrl(tools.hpAPIBaseURL(), '/SsoResponse/'));
    }
    else {
        url = yield call(getUrl, ssoTarget);
    }

    if (url === "") throw new Error("SSO for user not authorized");

    var identity = sessionData.healthPlanUserProfile;
    var token = domainData.t;
    let par;
    var memid = domainData.hi || identity.memberUserClaims.memberHccId;
    if (isAmysis) {
        if (contractNo) {
            par = {
                method: 'post',
                headers: {
                    'Authorization': 'bearer ' + token,
                    "Content-type": "application/json"
                },
                body: JSON.stringify({
                    SsoTarget: ssoTarget,
                    Id: memid,
                    ContractNumber: contractNo
                })
            };
        }
        else {
            par = {
                method: 'post',
                headers: {
                    'Authorization': 'bearer ' + token,
                    "Content-type": "application/json"
                },
                body: JSON.stringify({
                    SsoTarget: ssoTarget,
                    Id: memid
                })
            };
        }
    }
    else {
        par = {
            method: 'post',
            headers: {
                "Content-type": "application/json"
            },
            body: JSON.stringify({
                SsoTarget: ssoTarget,
                Id: memid,
                Jwt: token
            })
        };
    }

    var response = yield fetch(url, par).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.SSO.SsoSaml", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.SSO.SsoSaml.Failure", start, url, err); return Promise.reject(err);
    });

    ssoWindow.document.write(response.OpeningMessage + '<br>');
    if (!response.Success) {
        //Error handling
        ssoWindow.document.write(response.ErrorMessage ? esponse.ErrorMessage : 'Sorry, something went wrong.');
        throw new Error("Sorry, something went wrong.");
    }

    if (response.UseRedirectToUrl) {
        console.log('redirecting to', url);
        ssoWindow.location.replace(response.Url);
    }

    const params = {
        RelayState: response.RelayState,
        SAMLResponse: response.SamlText,
        Jwt: response.Jwt,
        ClientId: response.ClientId
    };
    console.log('params 2', params);
    yield call(formPostSubmit, ssoWindow, response.Url, params, "post");
}

function* formPostSubmit(ssoWindow, url, params, method) {
    const form = ssoWindow.document.createElement('form');
    form.method = method || "post";
    form.action = url;

    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            const hiddenField = document.createElement('input');
            hiddenField.type = 'hidden';
            hiddenField.name = key;
            hiddenField.value = params[key];

            form.appendChild(hiddenField);
        }
    }

    ssoWindow.document.body.appendChild(form);
    form.submit();
    console.log('form submitted');
}